import React, { Component } from "react";
import PropTypes from "prop-types";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import CalendarSponsorForm from "components/Calendar/Calendar";
import inputFormatter from "services/userInputFormatter";
import { connect } from "react-redux";
import actions from "actions/index";
import _ from "lodash";
import moment from "moment";
import { toast } from "react-toastify";
import { findBlocked, findBlockedInRange, blockedMessage } from "services/bankHolidays";

const { loadCalendarBookings, createCalendarBooking } = actions;

class CalendarSponsor extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    createCalendarBooking: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj,
  };

  constructor(props) {
    super(props);
    const startOfYear = moment().subtract(30, "days").format("YYYY/MM/DD");
    const endOfYear = moment().add(30, "days").format("YYYY/MM/DD");
    const period = `${startOfYear} - ${endOfYear}`;

    this.state = {
      startDate: null,
      endDate: null,
    };
    this.state = {
      termsOfService: false,
      termsOfServiceSpeaker: false,
      speakerAgreement: false,
      speakerSearch: false,
      booking: {
        webinar_title: "",
        user_id: "",
        location: "",
        accreditation: "",
        providing_speaker: false,
        sponsor: "",
        start_date: moment().set("seconds", 0),
        end_date: moment().set("seconds", 0),
        user_types: [0, 1, 2, 3, 4, 6, 7, 8],
        email: "",
        phone: "",
        booking_experts_attributes: [
          {
            name: "",
            location: "",
            expert_type: "",
          },
        ],
      },
      period,
    };
    this.props.loadCalendarEvents(period);
  }

  componentDidMount() {
    const user = localStorage.user && JSON.parse(localStorage.user);
    const showBookingToast = localStorage.getItem("show_booking_toast");
    if (showBookingToast) {
      toast.success("Thank you, your booking has been received");
      localStorage.removeItem("show_booking_toast");
    }
    if (user && user.id && user.role !== "admin") {
      const { email, phone, first_name } = user;

      this.setState({
        ...this.state,
        booking: {
          ...this.state.booking,
          contact_name: first_name,
          email,
          phone,
        },
      });
    }
  }

  componentWillReceiveProps(props) {
    if (
      !_.isEqual(this.props.bookings, props.bookings) ||
      !_.isEqual(this.state.bookings, props.bookings)
    ) {
      this.setState({
        bookings: props.bookings.map((event) => ({
          ...event,
          title: event.webinar_title,
          start: new Date(event.start_date),
          end: new Date(event.end_date),
        })),
      });
    }
  }

  onFieldChange = (e) => {
    console.log("onFieldCHange");
    const fieldValue = [...e.target.value];
    let input = inputFormatter.formatField(e.target.name, e.target.value);

    const bookingData = {
      ...this.state.booking,
      ...{
        [e.target.name]: input,
      },
    };
    if (e.target.name === "user_types") {
      const ipnaMemberIndex = fieldValue.indexOf(8);

      if (ipnaMemberIndex > -1) {
        fieldValue[ipnaMemberIndex] = 8;
      }
    }
    this.setState({ booking: bookingData });
  };

  onBookingExpertsAttributesChange = (e, index) => {
    let input = inputFormatter.formatField(e.target.name, e.target.value);

    const bookingData = {
      ...this.state.booking,
    };

    bookingData.booking_experts_attributes[index][e.target.name] = input;
    this.setState({ booking: bookingData });
  };

  onAddExpert = () => {
    const bookingData = {
      ...this.state.booking,
    };

    bookingData.booking_experts_attributes.push({
      name: "",
      location: "",
      expert_type: "",
    });
    this.setState({ booking: bookingData });
  };

  onRemoveElement = (index) => {
    const bookingData = {
      ...this.state.booking,
    };

    bookingData.booking_experts_attributes.splice(index, 1);
    this.setState({ booking: bookingData });
  };

  onDateChange = (field, value) => {
    // Always store what the field shows; blocked dates are warned about here
    // and rejected on submit (and by the API).
    const blocked = findBlocked(this.props.holidays, value);
    if (blocked) {
      toast.warning(blockedMessage(blocked, value));
    }
    const booking = {
      ...this.state.booking,
      ...{
        [field]: value,
      },
    };
    this.setState({ booking });
  };

  onUserTypeChangeCalendar = (roles) => {
    const rolesValue = (roles || []).map((role) => role.value);

    this.onFieldChange({
      target: {
        name: "user_types",
        value: (roles || []).map((role) => role.value),
      },
    });

    this.props.loadCalendarEvents(this.state.period, rolesValue);
  };

  onBookingChange = (e) => {
    const fieldValue = [...e.target.value];
    let input = inputFormatter.formatField(e.target.name, e.target.value);
    const bookingData = {
      ...this.state.booking,
      ...{
        [e.target.name]: input,
      },
    };
    this.setState({ booking: bookingData });
  };

  onAccreditationChange = (e) => {
    const accreditation = parseInt(e.target.value);

    this.onBookingChange({
      target: {
        name: "accreditation",
        value: accreditation,
      },
    });
  };

  onProvidingSpeakerChange = (e) => {
    const providing_speaker = e.target.value;
    console.log("onProvidingSpeakerChange");
    this.onBookingChange({
      target: {
        name: "providing_speaker",
        value: providing_speaker === "true",
      },
    });
  };

  onTextAreaChange = (e) => {
    const comment = e.target.value;

    this.onBookingChange({
      target: {
        name: "comment",
        value: comment,
      },
    });
  };

  onTermsOfServiceChange = () => {
    this.setState({
      ...this.state,
      termsOfService: !this.state.termsOfService,
    });
  };
  onWebinarSpeakerAgreement = () => {
    this.setState({
      ...this.state,
      speakerAgreement: !this.state.speakerAgreement,
    });
  };
  onWebinarSearchSpeaker = () => {
    this.setState({
      ...this.state,
      speakerSearch: !this.state.speakerSearch,
    });
  };

  onSubmit = (e) => {
    e.preventDefault();
    if (
      !this.state.speakerAgreement &&
      this.state.booking.providing_speaker === true
    ) {
      toast.warning(
        "A tick box on the organization of the Webinar Speaker Agreement is required"
      );
      return;
    }
    if (!this.state.speakerSearch) {
      toast.warning("Terms and conditions must be accepted");
      return;
    }
    if (!this.state.booking.webinar_title) {
      toast.warning("Webinar title required.");
      return;
    }
    if (this.state.booking.accreditation === "") {
      toast.warning("Accreditation required.");
      return;
    }
    if (!this.state.booking.user_types.length) {
      toast.warning("Please select a user type.");
      return;
    }
    if (!this.state.booking.email && "is_sponsor" === false) {
      toast.warning("Email required.");
      return;
    }
    if (!this.state.booking.contact_name && "is_sponsor" === false) {
      toast.warning("Contact required.");
      return;
    }
    if (!this.state.booking.phone && "is_sponsor" === false) {
      toast.warning("Phone required.");
      return;
    }
    const blocked = findBlockedInRange(
      this.props.holidays,
      this.state.booking.start_date,
      this.state.booking.end_date
    );
    if (blocked) {
      toast.warning(blockedMessage(blocked, this.state.booking.start_date));
      return;
    }
    const user = localStorage.user && JSON.parse(localStorage.user);

    this.props.createBooking({
      ...this.state.booking,
      user_id: user && user.id,
    });
  };

  onPeriodChange = ({ start, end }) => {
    if (!start || !end) {
      return;
    }

    const startPeriod = moment(start).format("YYYY/MM/DD");
    const endPeriod = moment(end).format("YYYY/MM/DD");
    const period = `${startPeriod} - ${endPeriod}`;

    this.setState({
      ...this.state.booking,
      period,
    });

    this.props.loadCalendarEvents(period);
  };

  render() {
    const user = localStorage.user && JSON.parse(localStorage.user);
    const isAdmin = user && ["admin", "host"].indexOf(user.role) > -1;
    const isSponsor = user && user.user_type === "sponsor";

    const { errors, errorsFrontend } = this.props;
    return (
      <main className="site--width clearfix-c">
        <CalendarSponsorForm
          booking={this.state.booking}
          termsOfService={this.state.termsOfService}
          onTermsOfServiceChange={this.onTermsOfServiceChange}
          onWebinarSpeakerAgreement={this.onWebinarSpeakerAgreement}
          onWebinarSearchSpeaker={this.onWebinarSearchSpeaker}
          speakerSearch={this.speakerSearch}
          speakerAgreement={this.speakerAgreement}
          onUserTypeChangeCalendar={this.onUserTypeChangeCalendar}
          onDateChange={this.onDateChange}
          onFieldChange={this.onFieldChange}
          onBookingExpertsAttributesChange={
            this.onBookingExpertsAttributesChange
          }
          onAddExpert={this.onAddExpert}
          onRemoveElement={this.onRemoveElement}
          onBookingChange={this.onBookingChange}
          onAccreditationChange={this.onAccreditationChange}
          onProvidingSpeakerChange={this.onProvidingSpeakerChange}
          onPeriodChange={this.onPeriodChange}
          onSubmit={this.onSubmit}
          termsOfServiceSpeaker={this.termsOfServiceSpeaker}
          onTextAreaChange={this.onTextAreaChange}
          events={this.state.bookings}
          holidays={this.props.holidays}
          is_admin={isAdmin}
          is_sponsor={isSponsor}
          user={this.state.user}
        />
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  bookings: state.bookings && state.bookings.values,
  holidays: (state.bookings && state.bookings.holidays) || [],
});

const mapDispatchToProps = (dispatch) => ({
  loadCalendarEvents: (period, userTypes) =>
    dispatch(loadCalendarBookings(period, userTypes)),
  createBooking: (booking) => dispatch(createCalendarBooking(booking)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarSponsor);



// WEBPACK FOOTER //
// ./src/containers/Calendar/Calendar.jsx